<template>
	<div id="body">
		<div class="title">
			<i class="el-icon-goods"></i> 充值 / 付款
		</div>
    <div class="content">
      <div style="padding-top: 20px"></div>

      <div v-if="backImg.length>0" style="width: 100%;" >
        <el-carousel :interval="5000" arrow="always" height="200px">
          <el-carousel-item v-for="item in backImg" :key="item.dictValue">
            <div class="demo">
              <img :src="item.dictLabel" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div style="margin-top: 20px;"></div>

      <div style="font-size: 14px; width: 90%; margin: 0 auto;"
           v-for="item in rechargeInfo"
           :key="item.dictValue"
           v-if="rechargeInfo.length>0">
        <div>
          <img src="../assets/hot.jpg" style="margin-bottom: 3px; width: 30px; height: 30px; margin-top: -13px" v-if="item.dictValue == 1">
          <b>{{item.dictLabel}}</b>
        </div>
      </div>

      <div style="padding-top: 20px"></div>

      <el-row :gutter="15" style="margin: 0 auto; text-align: center;">
        <el-radio-group v-model="totalFee" v-for="item in data" size="small">
          <el-col :span="5" style="margin-top: 20px">
            <el-radio :label="item.dictValue" border>
              <span class="t-color">{{ item.dictValue }}次/{{ item.dictLabel }}元</span>
            </el-radio>
          </el-col>
        </el-radio-group>
      </el-row>


      <div style="padding-top: 20px"></div>
      <el-button type="primary" style="width: 95%; display: block; margin: 0 auto;" @click="recharge">充 值</el-button>

      <div style="padding-top: 20px"></div>
    </div>

	</div>
</template>

<script>
	export default {
    name: "",
    data() {
      return {
        data: [],
        rechargeInfo: [],
        backImg: [],
        text: '',
        totalFee: "1",
        appId: '',
        timeStamp: '',
        nonceStr: '',
        package: '',
        signType: '',
        paySign: '',
        openId: '',

        res: {},
        msg: '',
      };
    },
    methods: {

      isUndefined() {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        } else {
          this.onBridgeReady();
        }
      },

      onBridgeReady() {
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              "appId": this.appId,     //公众号ID，由商户传入
              "timeStamp": this.timeStamp,     //时间戳，自1970年以来的秒数
              "nonceStr": this.nonceStr,      //随机串
              "package": this.package,
              "signType": this.signType,     //微信签名方式：
              "paySign": this.paySign, //微信签名
            }),
            function (res) {
              alert(JSON.stringify(res))
              if (res.err_msg == "get_brand_wcpay_request:cancel") {
                alert('支付取消');
              } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                alert('支付失败');
                WeixinJSBridge.call('closeWindow');
              } else if (res.err_msg == "get_brand_wcpay_request:ok") {
                alert('支付成功');
              }
            }
      },


      getRechargeFrequency() {
        this.$api({
          method: 'get',
          url: '/mobileLogin/getRechargeFrequency'
        }).then(res => {
          for (let i = 0; i < res.data.data.length; i++) {
            if(res.data.data[i].remark == this.$route.query.remark){
              this.data.push(res.data.data[i])
            }
          }
        })
      },

      getBackImg() {
        this.$api({
          method: 'get',
          url: '/mobileLogin/getBackImg'
        }).then(res => {
          this.backImg = res.data.data
        })
      },

      getRechargeInfo() {
        this.$api({
          method: 'get',
          url: '/mobileLogin/rechargeInfo'
        }).then(res => {
          this.rechargeInfo = res.data.data
        })
      },

      recharge() {
        this.$api({
          method: 'get',
          url: '/mobileLogin/JSAPI?openId=' + this.openId + "&totalFee=" + this.totalFee,
        }).then(res => {
          if (res.data.code == 200) {
            this.appId = res.data.data.appId
            this.timeStamp = res.data.data.timeStamp
            this.nonceStr = res.data.data.nonceStr
            this.package = res.data.data.package
            this.signType = res.data.data.signType
            this.paySign = res.data.data.paySign

            this.isUndefined()
          }

        })
      },
    },

    created() {
      this.openId = this.$route.query.openId
      this.getRechargeFrequency()
      this.getBackImg()
      this.getRechargeInfo()
    }

  }
</script>

<style scoped="scss">

.demo{
  width: 100%;
  height: 100%;
  display: table-cell; /*主要是这个属性*/
  vertical-align: middle;
  text-align: center;
}
.demo img{
  width: 95%;
}

  .content {
    width: 95%;
    display: block;
    margin: 0 auto;
    background-color: #FFFFFF;
  }

  .t-color{
    color: #0c0c0c;
  }

</style>
